import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import UrlEncryptionService from '@Helpers/UrlEncryptionService';

const urlEncryptionService = new UrlEncryptionService();

const useParamHook = (paramKey) => {
    const params = useParams();

    const decryptData = useMemo(() => {
        const encryptedValue = params?.[paramKey];

        if (!encryptedValue) return null;

        try {
            return urlEncryptionService.decryptData(encryptedValue);
        } catch (error) {
            console.error('Failed to decrypt param:', error);
            return null;
        }
    }, [params, paramKey]);

    return decryptData;
};

export default useParamHook;